// extracted by mini-css-extract-plugin
export default {"RestaurantPageContainer":"RestaurantPage_RestaurantPageContainer__njIJ1","PageContainer":"RestaurantPage_PageContainer__yTKWA"};